// extracted by mini-css-extract-plugin
module.exports = {"user":"styles--user--3Ocio","right":"styles--right--1sEYw","minHeight":"styles--minHeight--f6i-b"};